// extracted by mini-css-extract-plugin
export default {"messagingTemplatePreviewContainer":"messaging-template-preview-container__messaging-template-preview-container__shion"};